export default {
  getFile(state) {
    return state.file;
  },
  getFiles(state) {
    return state.files;
  },
  getFilesMap(state) {
    return state.files.reduce((prev, next) => {
      const { id } = next;
      prev[id] = next;
      return prev;
    }, {});
  },
  getDefaultFileTypes(state) {
    return state.defaultFileTypes;
  },
  getDefaultFileTypesMap(state) {
    return state.defaultFileTypes.reduce((prev, next) => {
      const { id } = next;
      prev[id] = next;
      return prev;
    }, {});
  },
  getDefaultFileTypesAccept(state) {
    return state.defaultfileTypesAccept;
  },
};
